import React from "react";

const Header = () => {
  return (
    <>
      <div className="mainHeader">
        <img src="/logoBackgroundless.png" alt="website logo" height="100" />
        <nav className="headerMenu">
          <a class="active" href="/">
            About
          </a>
          <a href="/portfolio">Portfolio</a>
          <a href="Contact">Contact</a>
          <a href="https://www.linkedin.com/in/beadelrosario/">LinkedIn</a>
          <input type="text" class="searchBar" placeholder="Search..." />
          {/* <button type="submit"><i class="fa fa-search"></i></button> */}
        </nav>
      </div>
    </>
  );
};

export default Header;
